<template>
  <div>
    <div v-if="isShowCountdownBook" class="boxCountdown text-center">
      <span>Selesaikan pembayaran dalam waktu {{ hour }}:{{ minute }}:{{ second }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    isShowCountdownBook: false,
    hour: '00',
    minute: '00',
    second: '00'
  }),
  computed: {
    appointmentBook () {
      return this.$store.state.doctor.appointmentBook
    },
    selectedAppointment () {
      return this.$store.state.doctor.booking.selectedAppointment
    },
    stepComponent () {
      return this.$store.state.doctor.stepComponent
    }
  },
  watch: {
    appointmentBook: {
      handler (value) {
        if (value) {
          this.showCountdownBook(value.BookingCountdown)
        }
      }
    }
  },
  mounted () {
    if (this.stepComponent === 'list-payments') {
      this.showCountdownBook(this.appointmentBook.BookingCountdown)
    }
  },
  methods: {
    showCountdownBook (duration) {
      let timer = duration
      this.timerIntervalBook = setInterval(() => {
        const seconds = timer % 60
        const secondsInMinutes = (timer - seconds) / 60
        const minutes = secondsInMinutes % 60
        const hours = (secondsInMinutes - minutes) / 60
        this.hour = String(hours).padStart(2, '0')
        this.minute = String(minutes).padStart(2, '0')
        this.second = String(seconds).padStart(2, '0')
        if (hours === 0 && minutes < 5) {
          this.isShowCountdownBook = true
        }
        --timer
        if (minutes === 0 && seconds < 0) {
          this.fetchNextSchedule()
          clearInterval(this.timerIntervalBook)
        }
      }, 1000)
    },
    fetchNextSchedule () {
      this.$store.dispatch('doctor/nearest', {
        did: this.$route.params.doctorNickName
      })
        .then((res) => {
          this.$parent.$parent.doctorProfile = res
          if (res.Appointments) {
            this.$store.commit('doctor/SET_COUNTDOWN_OFF', true)
            this.$store.commit('doctor/SET_PAYMENT', null)
            this.$store.commit('doctor/SET_PAYMENT_INDEX', null)
            this.isShowCountdownBook = false
          } else {
            this.backToHome()
          }
        })
        .catch((error) => {
          throw new Error(error)
        })
    },
    backToHome () {
      this.$router.push(this.$route.fullPath)
      this.$store.commit('doctor/SET_STEP', 'initial')
      localStorage.setItem('step', 'initial')
    }
  },
  beforeDestroy () {
    if (this.stepComponent !== 'confirmation' || this.stepComponent !== 'list-payments') {
      clearInterval(this.timerIntervalBook)
    }
  }
}
</script>

<style lang="scss">
  .boxCountdown {
    color: #ffffff;
    font-size: 15px;
    padding: 10px 5px;
    background: #024668;
  }
</style>
